export enum Role {
  GC_View = 'connect:gift-card-viewer',
  GC_Edit = 'connect:gift-card-editor',
  GC_Export = 'connect:gift-card-export',
}
